/* 하단탭메뉴(nav) Mixin */

export default {
  computed: {
    scrollViewStyle() {
      let height =
        document.body.offsetHeight - this.$store.getters.HEIGHT_BOTTOM_NAV;

      if (this.$store.getters.IS_IOS) height -= 36; // ios 바텀영역 제외
      return `min-height: ${height}px;max-height: ${height}px`;
    },
  },

  methods: {
    /* 메인 탭 화면 뒤로가기 방지 */
    handlePopstate() {
      history.go(1);
    },
  },

  created() {
    window.history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.handlePopstate);
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopstate);
  },
};
